import { NgTemplateOutlet } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'instrument-details-related-links',
  imports: [TranslocoPipe, NgTemplateOutlet],
  templateUrl: './related-links.component.html',
})
export class RelatedLinksComponent {
  @Input() public isin: string;
}
